/**
 * Find out if platform is IOS or android
 */
const useMobilePlatform = (): 'android' | 'ios' | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const userAgent = window.navigator.userAgent || window.navigator.vendor || (window as any).opera;

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'ios';
  }

  // Unknown.
  return null;
};

export default useMobilePlatform;
